import React from 'react';
import { XIcon } from 'lucide-react';
export const ProductDetailsDrawer = ({
  product,
  onClose
}) => {
  const handleSelectProduct = () => {
    // Dispatch event to add product to cart
    const category = getProductCategory(product);
    window.dispatchEvent(new CustomEvent('add-to-cart', {
      detail: {
        type: category,
        product
      }
    }));
    onClose();
  };
  // Helper function to determine product category
  const getProductCategory = product => {
    if (product.name.includes('Checking')) return 'checking';
    if (product.name.includes('Savings')) return 'savings';
    if (product.name.includes('Loan')) return 'loans';
    if (product.name.includes('Certificate') || product.name.includes('Month')) return 'certificates';
    return 'other';
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end" data-id="element-451">
      <div className="bg-white rounded-t-xl w-full p-6 max-h-[85vh] overflow-y-auto animate-slide-up" data-id="element-452">
        <div className="flex justify-between items-center mb-4" data-id="element-453">
          <button onClick={onClose} className="p-1" data-id="element-454">
            <XIcon size={24} data-id="element-455" />
          </button>
        </div>
        <h2 className="text-2xl font-bold mb-2" data-id="element-456">{product.name}</h2>
        <p className="text-gray-700 mb-4" data-id="element-457">{product.details.intro}</p>
        {product.details.features.map((feature, index) => <div key={index} className="mb-4" data-id="element-458">
            <h3 className="font-bold text-lg" data-id="element-459">{feature.title}</h3>
            <p className="text-gray-700" data-id="element-460">{feature.description}</p>
          </div>)}
        <button className="w-full bg-[#5c5cf5] text-white py-3 rounded-full font-medium mt-4" onClick={handleSelectProduct} data-id="element-461">
          Select Product
        </button>
      </div>
    </div>;
};